import { AppRoutes } from 'domain/routes';
import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { Link, Outlet } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Text, LinkHeader, ErrorBoundary } from 'components';
import { AppShell, Navbar } from 'layout';
import { RoleGuard } from 'components/RoleGuard';
import es from 'date-fns/locale/es';
registerLocale('es', es);
import 'react-datepicker/dist/react-datepicker.css';

export const RootPage = () => {
	const { t } = useTranslation(['entities', 'labels']);

	const [currentYear, setCurrentYear] = React.useState(new Date());
	return (
		<ErrorBoundary fallback={<div>{t('labels:error')}</div>}>
			<Suspense fallback={<div>{t('labels:loading')}</div>}>
				<AppShell>
					<AppShell.Header>
						<Navbar>
							<Navbar.Main>
								<Navbar.Brand>
									<Link to={AppRoutes.Dashboard}>
										<Text className='text-primary-0 text-xl font-light'>
											{t('labels:title')}
										</Text>
									</Link>
								</Navbar.Brand>
								<Navbar.Toggle />
							</Navbar.Main>
							<Navbar.Collapse className='md:h-full md:py-0'>
								<LinkHeader to={AppRoutes.Panel}>
									{t('entities:panel')}
								</LinkHeader>
								<LinkHeader to={AppRoutes.Dashboard}>
									{t('entities:dashboards')}
								</LinkHeader>
								<LinkHeader to={AppRoutes.Alerts}>
									{t('entities:alerts')}
								</LinkHeader>
								<RoleGuard role='ROLE_ADMIN'>
									<LinkHeader to={AppRoutes.Derived}>
										{t('entities:derived')}
									</LinkHeader>
								</RoleGuard>
								<RoleGuard role='ROLE_ADMIN'>
									<LinkHeader to={AppRoutes.Stations}>
										{t('entities:stations')}
									</LinkHeader>
								</RoleGuard>
								<RoleGuard role='ROLE_ADMIN'>
									<LinkHeader to={AppRoutes.Users}>
										{t('entities:users')}
									</LinkHeader>
								</RoleGuard>
								<RoleGuard role='ROLE_ADMIN'>
									<LinkHeader to={AppRoutes.Crops}>
										{t('entities:crops')}
									</LinkHeader>
								</RoleGuard>
							</Navbar.Collapse>
							<Navbar.Collapse className='ml-auto md:h-full md:py-0'>
								<LinkHeader to={AppRoutes.Logout}>
									{t('labels:logout')}
								</LinkHeader>
							</Navbar.Collapse>
						</Navbar>
					</AppShell.Header>
					<AppShell.Content>
						<Outlet />
					</AppShell.Content>
					<AppShell.ModalContainer />
					<AppShell.AlertManager />
				</AppShell>

				<div className='fixed bottom-0 right-0 z-50 flex w-20 justify-center rounded-tl bg-primary p-2'>
					<DatePicker
						showYearPicker
						dateFormat={'yyyy'}
						scrollableYearDropdown
						className='w-20 max-w-[46px] bg-transparent font-bold text-white'
						selected={currentYear}
						onChange={(date) => {
							setCurrentYear(new Date(date ?? new Date()));
						}}
					/>
				</div>
			</Suspense>
		</ErrorBoundary>
	);
};

export { RootPage as default };
